import { render, staticRenderFns } from "./ApprovalBarangHilang.vue?vue&type=template&id=753d47a0&"
import script from "./ApprovalBarangHilang.vue?vue&type=script&lang=js&"
export * from "./ApprovalBarangHilang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports